import React from "react"
import styles from "./ToggleIcon.module.scss"
import { faAngleRight } from "@fortawesome/pro-light-svg-icons/faAngleRight"
import cn from "classnames"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"

interface ToggleIconProps {
    isExpanded?: boolean
}

const ToggleIcon = ({ isExpanded }: ToggleIconProps) => {
    return (
        <FontAwesomeIcon
            icon={faAngleRight}
            size="lg"
            className={cn(styles.arrow, isExpanded && styles.arrow_expanded)}
        />
    )
}

export default ToggleIcon
